const validateWith2Array = (prev,curr) =>{
    if(prev.length !== curr.length) return true;

    for(let i=0; i<prev.length; i++){
        if(prev[i]!=curr[i])
            return true;
    }
    return false;
}

const validateChangeAtButton = (prev,form) =>{
    if(prev.length !== form?.length) return true;

    for(let i=0; i<prev.length; i++){
        if(prev[i]!=form[i]?.value)
            return true;
    }
    return false;
}

const savePreviousState = (form) =>{
    let prevState = [];
    for(let i=0; i<form?.length; i++){
        prevState.push(form[i].value);
    }
    return prevState;
}


function compareObjects(prevState, currState) {
    for (const key in currState) {
      if (currState.hasOwnProperty(key)) {
        if (!prevState.hasOwnProperty(key) || prevState[key] !== currState[key]) {
          return false;
        }
      }
    }
    //returns true if both are same false if any changes
    return true;
}

export {validateChangeAtButton,validateWith2Array, savePreviousState, compareObjects};




// prev => previous state as array
// curr => current state as array
// Note : the prev & curr || form has to be in same order.


